<div class="master-panel" [ngClass]="{ fullscreen: isFullscreen }">
    <!-- Panel Header -->
    <div class="panel-header">
        <h3 class="panel-title">
            Master Grid
            <span class="entity-name" *ngIf="selectedEntity">
                <i class="material-icons">table_chart</i>
                <span class="entity-text">{{ selectedEntity.entityName }}</span>
            </span>
        </h3>

        <div class="panel-header-actions">
            <button class="refresh-toggle-btn" (click)="onRefreshMasterGrid()" [disabled]="noRecordSelected || shouldReloadGrid || !selectedEntity" title="Refresh grid data">
                <i class="material-icons" [class.spinning]="shouldReloadGrid">refresh</i>
            </button>
            <button class="fullscreen-toggle-btn" (click)="onToggleFullscreen()" [title]="isFullscreen ? 'Exit Fullscreen' : 'Enter Fullscreen'">
                <i class="material-icons">
                    {{ isFullscreen ? 'fullscreen_exit' : 'fullscreen' }}
                </i>
            </button>
        </div>
    </div>

    <!-- Master Grid Container -->
    <div class="master-grid-container">
        <td-grid
            *ngIf="masterGridOptions && selectedEntity && gridServerSideDatasource && !shouldReloadGrid"
            [id]="currentGridId"
            [gridOptions]="masterGridOptions"
            [serverSideDatasource]="gridServerSideDatasource"
            [rowModelType]="'serverSide'"
            [columnDefs]="masterGridOptions.columnDefs"
            [defaultColDef]="masterGridOptions.defaultColDef"
            [rowSelection]="masterGridOptions.rowSelection"
            [rowMultiSelectWithClick]="masterGridOptions.rowMultiSelectWithClick"
            [suppressNoRowsOverlay]="masterGridOptions.suppressNoRowsOverlay"
            [pagination]="masterGridOptions.pagination"
            [paginationPageSize]="masterGridOptions.paginationPageSize"
            [paginationPageSizeSelector]="masterGridOptions.paginationPageSizeSelector"
            [localeText]="masterGridOptions.localeText"
            [aiSearchQuery]="aiSearchQuery"
            [editType]="'fullRow'"
            [suppressClickEdit]="true"
            (gridReady)="onMasterGridReady($event)"
            (rowSelected)="onMasterRowSelect($event)"
            (aiSearchQueryApplied)="onAISearchQueryApplied($event)"
            (rowDoubleClicked)="onRowDoubleClicked($event)"
            (rowEditingStopped)="onMasterRowEditingStopped($event)"
        ></td-grid>

        <!-- No Data Message -->
        <div *ngIf="noRecordSelected" class="no-data-message">
            <div class="message-content">
                <i class="material-icons">info</i>
                <p>Select an entity to view data</p>
            </div>
        </div>
    </div>
</div>
